import React from "react";
import { Sparklines, SparklinesLine } from "react-sparklines";
import { FaUtensils, FaDollarSign } from "react-icons/fa";
import "./home.css";
import { useHistory } from 'react-router-dom';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Col, Row } from "reactstrap";
import { Doughnut } from 'react-chartjs-2';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import Layout from '../NewHeader/Layout';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
ChartJS.register(ArcElement, Tooltip, Legend);
const Dashboard = () => {
  const statsData = [
    { key: "Normal Order", value: 564321 },
    { key: "Credit Order", value: 1543 },
    { key: "Customers", value: 453 },
    { key: "Credit Customers", value: 453 },
  ];
  const history = useHistory();

  const [ loading, setLoading ] = useState(false);
  const [tables, setTables] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);
  const [topCreditCustomers, setTopCreditCustomers] = useState([]);
  const [upcomingOrders, setUpcomingOrders] = useState([]);
  const [recentPayments, setRecentPayments] = useState([]);
  const currentMonth = new Date().toISOString().slice(5, 7);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth); // Default to January
  const [selectedMonthTop, setSelectedMonthCustomer] = useState(currentMonth); // Default to January
  const [selectedCreditMonth, setSCreditCustomerMonth] = useState(currentMonth); // Default to January

  
  const orders = [
    { time: "11:15 PM (in 5 min)", name: "John Doe", orderNum: "#243212", dueIn: "Picked" },
    { time: "11:30PM (in 25 min)", name: "Alexander Tramp", orderNum: "#243212", dueIn: "Delivered" },
    { time: "11:35PM", name: "Jo Joeson", orderNum: "#243212", dueIn: "Shipping" },
    { time: "4:30PM", name: "Yellow Red", orderNum: "#243212", dueIn: "Delivered" },
    { time: "4:30PM", name: "Yellow Red", orderNum: "#243212", dueIn: "Delivered" },

  ];

  // Sample data for the days in the date header
  const dates = [
    { day: 'THU', date: 5, orders: 15 },
    { day: 'FRI', date: 6, orders: 3 },
    { day: 'SAT', date: 7, orders: 1 },
    { day: 'SUN', date: 8, orders: 1 },
    { day: 'MON', date: 9, orders: 1 },
    { day: 'TUE', date: 10, orders: 1 },
    { day: 'WED', date: 11, orders: 1 },
    { day: 'THU', date: 12, orders: 0 },
  ];
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const customers = [
    { name: 'John Doe', value: 100 },
    { name: 'Alexander Tramp', value: 80 },
    { name: 'Dieter Longname', value: 60 },
    { name: 'Melanie White', value: 50 },
    { name: 'George Black', value: 30 },
    { name: 'Steven Clarkson', value: 15 },
    { name: 'Medical Insurance Ltd', value: 10 }
  ];

  const maxValue = Math.max(...topCustomers.map(c => c.order_count));

  const payments = [
    { date: "Normal", status: "Picked", amount: "$15.50" ,payment:"Cash", name: 'John Doe'},
    { date: "Credit", status: "Delivered", amount: "$23.59",payment:"Cash", name: 'Alexander Tramp' },
    { date: "Normal", status: "Shipping", amount: "$23.59",payment:"Cash" , name: 'Dieter Longname'},
    { date: "Normal", status: "Shipping", amount: "$23.59",payment:"Cash" , name: 'Melanie White'},
    { date: "Credit", status: "Shipping", amount: "$23.59" ,payment:"Cash", name: 'Steven Clarkson'},
    { date: "Normal", status: "Picked", amount: "$15.50" ,payment:"Cash", name: 'John Doe'},
    { date: "Credit", status: "Delivered", amount: "$23.59",payment:"Cash", name: 'Alexander Tramp' },
    { date: "Normal", status: "Shipping", amount: "$23.59",payment:"Cash" , name: 'Dieter Longname'},
    { date: "Normal", status: "Shipping", amount: "$23.59",payment:"Cash" , name: 'Melanie White'},
    { date: "Credit", status: "Shipping", amount: "$23.59" ,payment:"Cash", name: 'Steven Clarkson'},
  ];
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [startIndex, setStartIndex] = useState(0);
  const generateUpcomingDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 0; i < 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push({
        day: date.toLocaleDateString('en-US', { weekday: 'short' }),
        date: date.getDate(),
        month: date.toLocaleDateString('en-US', { month: 'short' }),
        fullDate: date,
      });
    }
    return dates;
  };
  useEffect(() => {
    // fetchTables();
    fetchTopshops();
  }, [selectedDate]);
  useEffect(() => {
    fetchTables();
  }, [selectedMonth]);
  useEffect(() => {
   
    fetchRecentPayments();
  }, [selectedMonthTop]);

  useEffect(() => {
    fetchTopcustomers();
    fetchCreditcustomers();
  }, []);
  
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleTopCustomer = (event) => {
    setSelectedMonthCustomer(event.target.value);
  };
  

  const handleCreditCustomer = (event) => {
    setSCreditCustomerMonth(event.target.value);
  };

  const fetchTables = async () => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
  
    try {
      const response = await axios.get(
        `${var_api}booking-orders/quick-stats-count/${shop_id}/${selectedMonth}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      setTables(user);
    } catch (error) {
      setLoading(false);

      if (error.response && error.response.status === 401) {
        console.error("Unauthorized access - Redirecting to Sign-In page.");
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };




  const fetchTopshops = async () => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
  
    try {
      const response = await axios.get(
        `${var_api}booking-orders/top-upcoming-orders/${shop_id}/${formatDateToDDMMYYYY(selectedDate)}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      // setTables(user);
      setUpcomingOrders(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        console.error("Unauthorized access - Redirecting to Sign-In page.");
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };




  const fetchTopcustomers = async () => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
  
    try {
      const response = await axios.get(
        `${var_api}booking-orders/top-customers/${shop_id}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      setTopCustomers(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        console.error("Unauthorized access - Redirecting to Sign-In page.");
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };


  const fetchCreditcustomers = async () => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
  
    try {
      const response = await axios.get(
        `${var_api}booking-orders/top-credit-customers/${shop_id}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      setTopCreditCustomers(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        console.error("Unauthorized access - Redirecting to Sign-In page.");
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };


  //recent payments list
  const fetchRecentPayments = async () => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
  
    try {
      const response = await axios.get(
        `${var_api}booking-orders/recent-payment/${shop_id}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data.data;
      setRecentPayments(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };

  
  const upcomingDates = generateUpcomingDates();
  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };
  const formatDateToDDMMYYYY = (date) => {
    const selectedDate = new Date(date);
    return `${String(selectedDate.getDate()).padStart(2, '0')}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${selectedDate.getFullYear()}`;
  };

  //view orders for active order
  const handleorder = () => {
    history.push('/new-order')
  };


   //view orders for active order
   const handlePayments = () => {
    history.push('/admin-payment-report')
  };


  const handleNext = () => {
    if (startIndex + 7 < upcomingDates.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };
  const pieChartData = {
    labels: topCreditCustomers.map((customer) => customer.customer_name),
    datasets: [
      {
        data: topCreditCustomers.map((customer) => customer.order_count),
        backgroundColor: [
          '#66bb6a',  // Green
          '#81c784',  // Light green
          '#a5d6a7',  // Very light green
          '#c8e6c9',  // Pale green
          '#ffcc80',  // Light orange
          '#ffb74d',  // Orange
          '#ffa726',  // Dark orange
        ],
      },
    ],
};
const getStatusLabel = (status) => {
  const statusLabels = ["New", "In Progress", "Delivered"];
  return statusLabels[status] || "Cancelled (by Customer)";
};


  return (
    <><Layout>
    <div className="dashboards">
      <h4 className="mb-3">Welcome back, {localStorage.getItem('username')}</h4>
      {/* Quick Stats */}
    
      <div className="stats-container mb-2">
      <div className="order-header">
        <h4 style={{	fontWeight: "bold",marginBottom:"0px"}}>  <i class="bi bi-heart-pulse" style={{margin:"10px 5px"}}></i>Quick Stats</h4>          <span>
        <select
      className="form-select form-select-sm"
      aria-label=".form-select-sm example"
      style={{ width: "110px", height: "40px", border: "1px solid black" }}
      value={selectedMonth}
      onChange={handleMonthChange}
    >
      <option disabled value="">
        Select Month
      </option>
      {months.map((month) => (
        <option key={month.value} value={month.value}>
          {month.label}
        </option>
      ))}
    </select>
</span>
        </div>
        <div className="stats-container-flex mb-2">
  <div className="stat-column-flex with-divider">
    <div className="stat-column">
      <h4 className="text-success">Normal Order</h4>
      <h2>{tables.normal_count}</h2>
    </div>
  </div>
  <div className="stat-column-flex with-divider">
    <div className="stat-column">
      <h4 className="text-success">Credit Order</h4>
      <h2>{tables.credit_customer_count}</h2>
    </div>
  </div>
  <div className="stat-column-flex with-divider">
    <div className="stat-column">
      <h4 className="text-success">Customers</h4>
      <h2>{tables.customer_count}</h2>
    </div>
  </div>
  <div className="stat-column-flex">
    <div className="stat-column">
      <h4 className="text-success">Credit Customers</h4>
      <h2>{tables.credit_customer_count}</h2>
    </div>
  </div>
</div>


    </div>

      {/* Upcoming Orders */}
      {/* <div style={{display:"flex",width:"100%",gap: "20px"}}> */}
      <Row>
        <Col lg="6" className="mb-3">
      <div className="orders-section">
   
        <div className="order-header">
        <h4 style={{	fontWeight: "bold"}}>  <FaUtensils style={{marginRight:"5px"}} />Upcoming Orders</h4>   
               {/* <span>View all orders</span> */}
               <button className="btn btn-sm btn-success" onClick={handleorder}>View all orders</button>
        </div>

        <div className="date-header">
          <button onClick={handlePrevious} disabled={startIndex === 0} className="nav-button"><i class="bi bi-chevron-left"></i></button>
          <div className="date-row">
            {upcomingDates.slice(startIndex, startIndex + 7).map((dateObj, index) => (
              <div
                key={index}
                className={`date-column ${selectedDate.toDateString() === dateObj.fullDate.toDateString() ? 'selected' : ''}`}
                onClick={() => handleDateSelect(dateObj.fullDate)}
              >
                <span className="day">{dateObj.day}</span>
                <span className="date">{dateObj.date}</span>
                <span className="month">{dateObj.month}</span>
              </div>
            ))}
          </div>
          <button onClick={handleNext} disabled={startIndex + 7 >= upcomingDates.length} className="nav-button"><i class="bi bi-chevron-right"></i></button>
        </div>
      
       <div class="table-container"  style={{maxHeight:"200px",overflowY:"auto",fontSize:"13px"}}>
  <table class="table table-sm">
    <thead  >
      <tr>
        <th scope="col">S.No</th>
        <th scope="col">ORDER DATE</th>
        <th scope="col">ORDER FOR</th>
        <th scope="col">ORDER ID </th>
        <th scope="col">STATUS</th>
      </tr>
    </thead>
    <tbody>
  {upcomingOrders.length == 0 ? (
    <tr>
      <td colSpan="7" style={{ textAlign: "center", fontWeight: "bold", color: "4caf50" }}>
        No Data Available
      </td>
    </tr>
  ) : (
    upcomingOrders.map((order, index) => (
      <tr key={index}>
        <td>{index+1}</td>
        <td>{order.order_date}</td>
        <td>{order.customer_name}</td>
        <td>{order.order_no}</td>
        <td>
          {getStatusLabel(order.order_status)}
          <button
            onClick={handleorder}
            style={{ fontSize: "10px" }}
            className="nav-button"
          >
            <i className="bi bi-chevron-right"></i>
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>

  </table>
</div>

     
    </div>
    </Col>
    <Col lg="6" className="mb-3">
      {/* Recent Payments */}
      <div className="payments-section">
        <div className="payments">
          <div className="payment-header">
            
          <h4  style={{	fontWeight: "bold"}}><i class="bi bi-credit-card-fill" style={{margin:"10px 5px"}}></i>Recent Payments</h4>
          {/* <span>View all payments</span> */}
          <button className="btn btn-sm btn-success" onClick={handlePayments}>View all payments</button>
          </div>
         
          <div className="table-wrapper" style={{ maxHeight: '200px', overflowY: 'auto',fontSize:'13px'}}>
  <table className="table table-sm table-striped">
    <thead className="thead-fixed">
      <tr>
        <th scope="col">S.No</th>
        <th scope="col">ORDER TYPE</th>
        <th scope="col">CUSTOMER</th>
        <th scope="col">AMOUNT</th>
        <th scope="col">PAYMENT MODE</th>
      </tr>
    </thead>
    <tbody>
      {recentPayments.map((order, index) => (
        <tr key={index}>
          <td>{index+1}</td>
          <td>{order.order_type == 1 ? "Normal Order" : order.order_type == 2 ? "Credit Order" : "-"}</td>
          <td>{order.customer_name}</td>
          <td>{order.amount}</td>
          <td>
            {order.paymode_name || "-"}{" "}
            <button onClick={handlePayments} style={{ fontSize: "10px" }} className="nav-button">
              <i className="bi bi-chevron-right"></i>
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


        </div>
      </div>
      </Col>
      </Row>
      {/* </div> */}
      <Row>
        <Col lg="6">
      <div className="orders-section" style={{padding:"0px"}}>
      <div className="top-customers-container">
        <div style={{display:"flex",justifyContent:"space-between"}}>
      <h4 style={{    marginTop: "10px"}}><i class="bi bi-people-fill"  style={{margin:"10px 5px"}}></i>Top Customers</h4>
{/*      
            <span>
            <select
      className="form-select form-select-sm"
      aria-label=".form-select-sm example"
      style={{ width: "110px", height: "40px", border: "1px solid black" }}
      value={selectedMonthTop}
      onChange={handleTopCustomer}
    >
      <option disabled value="">
        Select Month
      </option>
      {months.map((month) => (
        <option key={month.value} value={month.value}>
          {month.label}
        </option>
      ))}
    </select>
</span> */}
</div>
      <hr className="mt-2 mb-2"></hr>
      {topCustomers.length === 0 ? (
        <p style={{ textAlign: "center", marginTop: "20px", color:"#4caf50" }}>No Data Available</p>
      ) : (
      <ul className="customer-list">
        {topCustomers.map((customer, index) => (
        
          <li key={index} className="customer-item">
              <Col lg="3" style={{textAlign:"end",marginRight:"10px"}}>
            <span className="customer-name">{customer.customer_name}</span></Col>
            <Col lg="6">
            <div
              className="customer-bar"
              style={{
                width: `${(customer.order_count / maxValue) * 100}%`
              }}
            ></div>
            </Col>
          </li>
        ))}
      </ul>
        )}
    </div>
    </div>
    </Col>
    <Col lg="6">
      <div className="orders-section" style={{ padding: '0px' }}>
        <div className="top-customers-container">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h4 style={{ marginTop: '10px' }}>
              <i className="bi bi-people-fill" style={{ margin: '10px 5px' }}></i>
              Top Credit Customers
            </h4>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

            {/* <span>
            <select
      className="form-select form-select-sm"
      aria-label=".form-select-sm example"
      style={{ width: "110px", height: "40px", border: "1px solid black" }}
      value={selectedCreditMonth}
      onChange={handleCreditCustomer}
    >
      <option disabled value="">
        Select Month
      </option>
      {months.map((month) => (
        <option key={month.value} value={month.value}>
          {month.label}
        </option>
      ))}
    </select>
            </span> */}
            </div>
          </div>
          <hr className="mt-2 mb-2" />
          {pieChartData.labels.length === 0 ? (
        <p style={{ textAlign: "center", marginTop: "20px", color:"#4caf50" }}>No Data Available</p>
      ) : (
          <div className="customer-pie-chart-container">
  {/* Labels Section */}
  <div className="chart-labels">
    {pieChartData.labels.map((label, index) => (
      <div key={index} className="chart-label">
        <span
          className="label-color-box"
          style={{ backgroundColor: pieChartData.datasets[0].backgroundColor[index] }}
        ></span>
        <span className="label-name">{label}</span>
      </div>
    ))}
  </div>

  {/* Pie Chart Section */}
  <div className="chart-wrapper">
    <div className="chart">
    <Pie data={pieChartData} options={{ maintainAspectRatio: false, plugins: { legend: { display: false } } }} />
    </div>
  </div>
</div>
      )}
        </div>
      </div>
    </Col>
    </Row>
    
    </div>
    </Layout></>
  );
};

export default Dashboard;
